import {
  ClientDto,
  TeamDto,
  UserTeamDto,
} from '@act/shared/data-transfer-objects';
import { ClientAuditorDto } from '@act/shared/data-transfer-objects';

export const getTeamNamesForUser = (
  usersTeams: UserTeamDto[],
  allTeams: TeamDto[]
): string[] => {
  return usersTeams
    ?.map(userTeam => {
      if (!userTeam) {
        return null;
      }
      const team = allTeams?.find(team => team?.id === userTeam?.teamId);
      const name = team ? team.name : 'Not Found';
      return `${name}${userTeam.isManager ? ' (manager)' : ''}`;
    })
    .filter(Boolean);
};

export const getClientNamesForUser = (
  userClients: ClientAuditorDto[],
  allClients: ClientDto[]
): string[] => {
  const uniqueClientNames = new Set<string>();
  userClients.forEach(clientId => {
    const client = allClients?.find(client => client.id === clientId.clientId);
    if (client) {
      uniqueClientNames.add(client.displayName);
    }
  });
  return Array.from(uniqueClientNames);
};
